module.exports = __webpack_public_path__ + "static/media/VECTO.1de772b9.svg";